import type { LoadTask } from '.';

export class TaskLoaderState {
    constructor() {}
    public NeedsLoading: Array<LoadTask> = [];
    public Failed: Array<LoadTask> = [];
    public Loaded: Array<Promise<void>> = [];
    public AllDone: boolean = true;
    public isActive: boolean = false;
}
